import { MenuItem, Select, TextField } from "@mui/material";
import { ModalRow, ModalTitle } from "../../components/modal/ModalCard";
import objectUtils from "../../utils/objectUtils";
import styled from "@emotion/styled";
import IGarbageCan from "../../models/garbage can/garbageCan";
import {
    EGarbageCanType,
    EGarbageCanTypeKeysType,
} from "../../models/garbage can/garbageCanType";
import { useTranslation } from "react-i18next";

interface GarbageCanCreationProps {
    garbageCan: IGarbageCan;
    setGarbageCan: Function;
}
const Container = styled("div")({
    marginTop: 10,
    height: 350,
    overflow: "auto",
    padding: 10,
});
const GarbageCanCreationStep = ({
    garbageCan,
    setGarbageCan,
}: GarbageCanCreationProps) => {
    const { t } = useTranslation(["sensor"]);
    const onChangeInput = (e: any) => {
        const { name, value } = e.target;
        setGarbageCan({ ...garbageCan, [name]: value });
    };

    return (
        <Container>
            <ModalRow sx={{ textAlign: "left", marginBottom: 5 }}>
                <ModalTitle> {t("sensor:sensor.type")} (*)</ModalTitle>
                <Select
                    name="type"
                    sx={{ width: "80%" }}
                    size="small"
                    value={garbageCan.type}
                    onChange={onChangeInput}
                >
                    {objectUtils.enumStringKeys(EGarbageCanType).map((type) => (
                        <MenuItem key={type} value={type}>
                            {t(
                                `sensor:waste.${
                                    EGarbageCanType[
                                        type
                                    ] as EGarbageCanTypeKeysType
                                }`
                            )}
                        </MenuItem>
                    ))}
                </Select>
            </ModalRow>
            <ModalRow sx={{ textAlign: "left", marginBottom: 5 }}>
                <ModalTitle> {t("sensor:garbageCan.height")} (cm)</ModalTitle>
                <TextField
                    name="height"
                    sx={{ width: "80%" }}
                    variant="outlined"
                    value={garbageCan.height}
                    onChange={onChangeInput}
                />
            </ModalRow>
            <ModalRow sx={{ textAlign: "left", marginBottom: 5 }}>
                <ModalTitle> {t("sensor:garbageCan.width")} (cm)</ModalTitle>
                <TextField
                    name="width"
                    sx={{ width: "80%" }}
                    variant="outlined"
                    value={garbageCan.width}
                    onChange={onChangeInput}
                />
            </ModalRow>
            <ModalRow sx={{ textAlign: "left", marginBottom: 5 }}>
                <ModalTitle> {t("sensor:garbageCan.length")} (cm)</ModalTitle>
                <TextField
                    name="length"
                    sx={{ width: "80%" }}
                    variant="outlined"
                    value={garbageCan.length}
                    onChange={onChangeInput}
                />
            </ModalRow>
        </Container>
    );
};
export default GarbageCanCreationStep;
